import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { UserSearchState } from '@/typings/store/states/UserSearchStoreState';

 const state: UserSearchState = {
    searchTerm: "",
    useSavedParams: false,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};